import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
// slices
import dailyPricingReducer from './slices/dailyPricing';
import userReducer from './slices/users';

// ----------------------------------------------------------------------
const rootPersistConfig = {
    key: 'root',
    storage,
    keyPrefix: 'redux-',
    whitelist: [],
};


const rootReducer = combineReducers({
    dailyPricing: dailyPricingReducer,
    users: userReducer,
});

export { rootPersistConfig, rootReducer };
